import * as Yup from 'yup';
import { cardPaymentCodes } from '../constants/appConstants';
import { DEFAULT_VALIDATION_MESSAGES } from '../hooks/useTranslatedMessages';

const defaultMessages = DEFAULT_VALIDATION_MESSAGES?.payment_means ?? {};

export const getPaymentMeansItemSchema = (messages = defaultMessages) =>
  Yup.object().shape({
    payment_means_code: Yup.string().required(messages.payment_mode_required),

    card_account: Yup.mixed().nullable(),
    payee_financial_account: Yup.mixed().nullable(),
    payment_mandate: Yup.object().nullable(),
  });

export const getPaymentMeansSchema = (messages = defaultMessages) =>
  Yup.array()
    .of(getPaymentMeansItemSchema(messages))
    .min(1, messages.payment_mode_required)
    .test('card-account-required', messages.pan_required, function (paymentMeans) {
      if (!paymentMeans || paymentMeans.length === 0) {
        return true;
      }

      const selectedCardPayments = paymentMeans.filter((pm) => cardPaymentCodes.includes(pm.payment_means_code));

      if (selectedCardPayments.length === 0) {
        return true;
      }

      const hasValidCardAccount = selectedCardPayments.some(
        (pm) => pm.card_account?.primary_account_number_id && pm.card_account?.network_id,
      );

      return hasValidCardAccount;
    });

/** @deprecated Prefer getPaymentMeansSchema(messages) with locale from useTranslatedMessages. */
export const paymentMeansSchema = getPaymentMeansSchema();
